import StorageTransformer from './StorageTransformer';

interface StorageStrategy {
  store(key: string, data: string): void;
  retrieve(key: string): string | undefined;
  remove(key: string): void;
}

class LocalStorage implements StorageStrategy {
  public store(key: string, data: string): void {
    localStorage.setItem(key, data);
  }

  public retrieve(key: string): string | undefined {
    return localStorage.getItem(key);
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

  public static clear() {
    localStorage.clear();
  }
}

class BrowserSessionStorage implements StorageStrategy {
  public store(key: string, data: string): void {
    sessionStorage.setItem(key, data);
  }

  public retrieve(key: string): string | undefined {
    return sessionStorage.getItem(key);
  }

  public remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  public static clear() {
    sessionStorage.clear();
  }
}

class StandardHttpCookiesStorage implements StorageStrategy {
  public store(key: string, data: string): void {
    const encodedData = btoa(data);
    document.cookie =
      key + '=' + encodedData + '; secure; path=/; SameSite=strict; domain=' + window.location.host.replace(/:\d+/, '');
  }

  public retrieve(key: string): string | undefined {
    const encodedData = StorageTransformer.getMapFromString(document.cookie, ';').get(key);
    return atob(encodedData);
  }

  public remove(key: string): void {
    const value = key + '=; ';
    const expiration = 'expires=0; ';
    const locationDomain = 'path=/; domain=' + window.location.host.replace(/:\d+/, '');
    document.cookie = value + expiration + 'secure; ' + locationDomain;
  }

  public static clear() {
    document.cookie = '';
  }
}

function clear() {
  LocalStorage.clear();
  BrowserSessionStorage.clear();
  StandardHttpCookiesStorage.clear();
}

export {
  // eslint-disable-next-line no-undef
  StorageStrategy,
  LocalStorage,
  BrowserSessionStorage,
  StandardHttpCookiesStorage,
  clear,
};
